import { createTheme, type PaletteMode } from '@mui/material/styles';

/**
 * Material Design 3 inspired palette: a single seed hue with tonal
 * surfaces for light/dark, kept deliberately restrained (no gradients,
 * no decorative color) so the UI reads as a calm operations tool.
 */
export function createAppTheme(mode: PaletteMode) {
  const isLight = mode === 'light';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isLight ? '#3760D6' : '#A9C1FF',
        contrastText: isLight ? '#FFFFFF' : '#0A234E',
      },
      secondary: {
        main: isLight ? '#5A5D72' : '#C3C5DD',
      },
      error: {
        main: isLight ? '#BA1A1A' : '#FFB4AB',
      },
      background: {
        default: isLight ? '#FAFAFD' : '#111318',
        paper: isLight ? '#FFFFFF' : '#1A1C22',
      },
    },
    shape: {
      borderRadius: 10,
    },
    typography: {
      fontFamily: [
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        'Helvetica',
        'Arial',
        'sans-serif',
      ].join(','),
      button: {
        textTransform: 'none',
        fontWeight: 600,
      },
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiAppBar: {
        defaultProps: {
          elevation: 0,
        },
        styleOverrides: {
          root: {
            borderBottom: '1px solid',
            borderColor: isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.08)',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
    },
  });
}
